<!-- メニュー -->
<app-menu class="no_print"></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- 戻る -->
    <div class="return no_print">
      <button
        pButton
        type="button"
        label="連携事例検索へ戻る"
        icon="pi pi-angle-left"
        class="p-button-text"
        (click)="moveH201()"
      ></button>
    </div>
    <!-- 課題タイトル -->
    <div class="cooperation-title">
      <!-- タイトルコンテンツ -->
      <div class="title-content">
        <!-- 事例タグ -->
        <div class="p-d-flex p-jc-center case-tag-area">
          <div>
            <i
              class="pi pi-star icon-type1"
              *ngIf="detailCooperation?.excellent_tag == '1'"
            ></i>
            <p-tag
              value="優良事例"
              styleClass="p-button-text tag-type1"
              *ngIf="detailCooperation?.excellent_tag == '1'"
            ></p-tag>
          </div>
          <div>
            <p-tag
              value="PF会員間連携"
              styleClass="p-button-text tag-type2"
              *ngIf="detailCooperation?.case_tag.includes('1')"
            ></p-tag>
          </div>
        </div>
        <!-- タイトル -->
        <div class="p-d-flex p-jc-center theme">
          {{ detailCooperation?.title }}
        </div>
        <div class="p-d-flex p-jc-center collaboration_name">
          {{ detailCooperation?.public_representative }} ×
          {{ detailCooperation?.private_representatibe }}
        </div>
        <div class="p-d-flex p-jc-center">
          （登録団体：{{ detailCooperation?.member_organization_name }}）
        </div>
        <div class="no_print">
          <!-- ボタンエリア -->
          <div
            class="p-d-flex p-jc-center button-area"
            *ngIf="
              decisionPerspective(this.detailCooperation?.member_id) ||
              decisionSecretariat()
            "
          >
            <div
              *ngIf="
                (detailCooperation?.status.id == 0 ||
                  detailCooperation?.status.name == '一時保存') &&
                !tempSaveFlg
              "
            >
              <button
                pButton
                type="button"
                label="登録"
                icon="pi pi-check"
                class="button3"
                (click)="regist()"
              ></button>
            </div>
            <button
              pButton
              type="button"
              label="編集"
              icon="pi pi-pencil"
              class="button1"
              (click)="moveH101()"
              *ngIf="detailCooperation?.status.id != 3"
            ></button>
            <button
              pButton
              type="button"
              label="印刷"
              icon="pi pi-print"
              class="jirei-button3"
              (click)="print()"
            ></button>
            <button
              pButton
              type="button"
              icon="pi pi-replay"
              class="jirei-button1"
              onClick="window.location.reload()"
            ></button>
          </div>
          <div
            *ngIf="tempSaveFlg && 2 != detailCooperation?.status.id"
            class="p-d-flex p-jc-center"
          >
            <label class="warning">未入力の必須項目があります。</label>
          </div>
        </div>
      </div>
    </div>
    <div class="warning-text no_print">
      <div *ngIf="2 != detailCooperation?.status.id">
        ※画像のアップロードに時間を要する場合があります<br />
      </div>
      ※画像が表示されない場合は画面の更新を行ってください
    </div>

    <!-- 内閣府承認情報 -->
    <div
      class="approval-information no_print"
      *ngIf="
        decisionPerspective(this.detailCooperation?.member_id) ||
        decisionSecretariat()
      "
    >
      <!-- 内閣府承認情報内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 内閣府承認 -->
          <tr>
            <td class="item-name">運営事務局承認</td>
            <td class="item-information">
              <div [class.denial]="3 == detailCooperation?.status.id">
                <div class="p-d-flex status">
                  <label class="p-as-center">
                    <!-- ステータス -->
                    <label class="status-name">
                      {{ detailCooperation?.status.name }}
                    </label>
                    <!-- 承認日付 -->
                    <label>
                      {{ detailCooperation?.status_date }}
                    </label>
                  </label>

                  <!-- 前後確認 -->
                  <button
                    pButton
                    type="button"
                    label="前後確認"
                    class="button3 confirmation-button"
                    (click)="openDiffDialog('h301')"
                    *ngIf="decisionSecretariat()"
                  ></button>

                  <!-- 承認可否 -->
                  <button
                    pButton
                    type="button"
                    label="ステータス登録"
                    class="button3 approval-button"
                    (click)="openSmallApprovalDialog()"
                    *ngIf="decisionSecretariat()"
                  ></button>
                </div>
                <!-- 承認時コメント -->
                <div class="status-comment">
                  {{ detailCooperation?.status_comment }}
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 課題の背景や詳細 -->
    <div class="cooperation-detail">
      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>取組概要</h2>
      </div>
      <div class="attempt-overview">
        <h3>{{ detailCooperation?.attemptoverview }}</h3>
      </div>
      <div class="p-d-flex p-jc-center img-contents">
        <div
          class="view-size"
          *ngIf="detailCooperation?.case_image1.file_path.length != 0"
        >
          <img
            [src]="detailCooperation?.case_image1.file_path"
            alt="image"
            id="case_image1"
            onerror="this.src= 'https://naikakufu-prod-file.s3.ap-northeast-1.amazonaws.com/image_proseccing.png'"
            [ngStyle]="setImageSize('case_image1')"
          />
        </div>
        <div
          class="view-size"
          *ngIf="detailCooperation?.case_image2.file_path.length != 0"
        >
          <img
            [src]="detailCooperation?.case_image2.file_path"
            alt="image"
            id="case_image2"
            onerror="this.src= 'https://naikakufu-prod-file.s3.ap-northeast-1.amazonaws.com/image_proseccing.png'"
            [ngStyle]="setImageSize('case_image2')"
          />
        </div>
      </div>
      <div class="p-d-flex p-jc-center img-contents">
        <div
          class="view-content"
          *ngIf="detailCooperation?.case_image1.file_path.length != 0"
        >
          <div class="text-caption">
            {{ detailCooperation?.case_image1_caption }}
          </div>
        </div>
        <div
          class="view-content"
          *ngIf="detailCooperation?.case_image2.file_path.length != 0"
        >
          <div class="text-caption">
            {{ detailCooperation?.case_image2_caption }}
          </div>
        </div>
      </div>

      <div class="information-margin-height"></div>

      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>基本情報</h2>
      </div>
      <!-- 事例情報 -->
      <div class="cooperation-detail-information">
        <!-- 事例内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 代表地方公共団体等 -->
            <tr *ngIf="detailCooperation?.public_representative.length != 0">
              <td class="item-name">代表地方公共団体等</td>
              <td class="item-information">
                {{ detailCooperation?.public_representative }}
              </td>
            </tr>
            <!-- 代表民間団体等  -->
            <tr *ngIf="detailCooperation?.private_representatibe.length != 0">
              <td class="item-name">代表民間団体等</td>
              <td class="item-information">
                {{ detailCooperation?.private_representatibe }}
              </td>
            </tr>
            <!-- タイトル -->
            <tr *ngIf="detailCooperation?.other_cooperation.length != 0">
              <td class="item-name">他の連携団体等</td>
              <td class="item-information">
                {{ detailCooperation?.other_cooperation }}
              </td>
            </tr>
            <!-- カテゴリ -->
            <tr>
              <td class="item-name">カテゴリ</td>
              <td class="item-information">
                <div *ngFor="let category of detailCooperation?.category">
                  {{ category.name }}
                </div>
              </td>
            </tr>
            <!-- 事業費 -->
            <tr *ngIf="detailCooperation?.business_cost.length != 0">
              <td class="item-name">事業費</td>
              <td class="item-information">
                {{ detailCooperation?.business_cost }}
              </td>
            </tr>
            <!-- 目指すSDGsゴール -->
            <tr>
              <td class="item-name">目指すSDGsゴール</td>
              <td class="item-information target-goal">
                <div
                  class="image"
                  *ngFor="let sdgs_goal of detailCooperation?.sdgs_goal"
                >
                  <img [src]="sdgs_goal.sp_ext" alt="image" />
                </div>
              </td>
            </tr>
            <!-- 事業化までの期間 -->
            <tr>
              <td class="item-name">事業化までの期間</td>
              <td class="item-information">
                {{ detailCooperation?.coopstart_season }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="information-margin-height"></div>

      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>取組内容</h2>
      </div>
      <!-- 事例情報 -->
      <div class="cooperation-detail-information">
        <div class="p-d-flex p-jc-center img-contents">
          <div
            class="view-size"
            *ngIf="detailCooperation?.overview_image1.file_path.length != 0"
          >
            <img
              [src]="detailCooperation?.overview_image1.file_path"
              alt="image"
              id="overview_image1"
              onerror="this.src= 'https://naikakufu-prod-file.s3.ap-northeast-1.amazonaws.com/image_proseccing.png'"
              [ngStyle]="setImageSize('overview_image1')"
            />
          </div>
          <div
            class="view-size"
            *ngIf="detailCooperation?.overview_image2.file_path.length != 0"
          >
            <img
              [src]="detailCooperation?.overview_image2.file_path"
              alt="image"
              id="overview_image2"
              onerror="this.src= 'https://naikakufu-prod-file.s3.ap-northeast-1.amazonaws.com/image_proseccing.png'"
              [ngStyle]="setImageSize('overview_image2')"
            />
          </div>
        </div>
        <div class="p-d-flex p-jc-center img-contents">
          <div
            class="view-content"
            *ngIf="detailCooperation?.overview_image1.file_path.length != 0"
          >
            <div class="text-caption">
              {{ detailCooperation?.overview_image1_caption }}
            </div>
          </div>
          <div
            class="view-content"
            *ngIf="detailCooperation?.overview_image2.file_path.length != 0"
          >
            <div class="text-caption">
              {{ detailCooperation?.overview_image2_caption }}
            </div>
          </div>
        </div>

        <!-- 事例内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- この取組で解決した課題 -->
            <tr>
              <td class="item-name">この取組で解決した課題</td>
              <td class="item-information">
                {{ detailCooperation?.clear_agenda }}
              </td>
            </tr>
            <!-- 解決に向けた手法 -->
            <tr>
              <td class="item-name">解決に向けた手法</td>
              <td class="item-information">{{ detailCooperation?.method }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="information-margin-height"></div>

      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>取組詳細</h2>
      </div>
      <!-- 事例情報 -->
      <div class="cooperation-detail-information">
        <!-- 事例内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 事業推進上の各団体の役割分担 -->
            <tr *ngIf="detailCooperation?.role_sharing.length != 0">
              <td class="item-name">事業推進上の各団体の役割分担</td>
              <td class="item-information">
                {{ detailCooperation?.role_sharing }}
              </td>
            </tr>
            <!-- 地域関係者との連携方法 -->
            <tr>
              <td class="item-name">地域関係者との連携方法</td>
              <td class="item-information">
                {{ detailCooperation?.coop_method }}
              </td>
            </tr>
            <!-- 資金調達方法 -->
            <tr>
              <td class="item-name">資金調達方法</td>
              <td class="item-information">
                {{ detailCooperation?.funding_plan }}
              </td>
            </tr>
            <!-- 資金調達方法の補足 -->
            <tr *ngIf="detailCooperation?.funding_plan_supplement.length != 0">
              <td class="item-name">資金調達方法の補足</td>
              <td class="item-information">
                {{ detailCooperation?.funding_plan_supplement }}
              </td>
            </tr>
            <!-- 事業推進上の課題・工夫 -->
            <tr>
              <td class="item-name">事業推進上の課題・工夫</td>
              <td class="item-information">
                {{ detailCooperation?.solution }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div *ngIf="detailCooperation?.responsible_person_comment.length != 0">
        <div class="information-margin-height"></div>
        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>担当者のコメント</h2>
        </div>
        <!-- 事例情報 -->
        <div class="cooperation-detail-information">
          <!-- 事例内容 -->
          <div class="p-d-flex personComment-contents">
            <div
              class="full-view-content"
              *ngIf="
                detailCooperation?.responsible_person_comment.length != 0 &&
                detailCooperation?.responsible_person_image.file_path.length ==
                  0
              "
            >
              <div class="text-comment">
                {{ detailCooperation?.responsible_person_comment }}
              </div>
            </div>
            <div
              class="left-view-content"
              *ngIf="
                detailCooperation?.responsible_person_comment.length != 0 &&
                detailCooperation?.responsible_person_image.file_path.length !=
                  0
              "
            >
              <div class="text-comment">
                {{ detailCooperation?.responsible_person_comment }}
              </div>
            </div>
            <div
              class="right-view-content"
              *ngIf="
                detailCooperation?.responsible_person_comment.length != 0 &&
                detailCooperation?.responsible_person_image.file_path.length !=
                  0
              "
            >
              <div
                class="view-size"
                *ngIf="
                  detailCooperation?.responsible_person_image.file_path
                    .length != 0
                "
              >
                <img
                  [src]="detailCooperation?.responsible_person_image.file_path"
                  alt="image"
                  id="responsible_person_image"
                  onerror="this.src= 'https://naikakufu-prod-file.s3.ap-northeast-1.amazonaws.com/image_proseccing.png'"
                  [ngStyle]="setImageSize('responsible_person_image')"
                />
              </div>
              <div
                class="caption-size"
                *ngIf="detailCooperation?.responsible_person_caption != 0"
              >
                <div class="text-caption">
                  {{ detailCooperation?.responsible_person_caption }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="information-margin-height"></div>

      <div
        *ngIf="
          (detailCooperation?.cooperation_open.id == 1 ||
            (detailCooperation?.cooperation_open.id == 2 &&
              this.decisionLoginState()) ||
            (detailCooperation?.cooperation_open.id == 3 &&
              this.decisionPerspective(this.detailCooperation.member_id)) ||
            this.decisionSecretariat()) &&
          (detailCooperation?.organization_name.length != 0 ||
            detailCooperation?.divition_name.length != 0 ||
            detailCooperation?.responsible_person_name.length != 0 ||
            detailCooperation?.tel.length != 0 ||
            detailCooperation?.email.length != 0)
        "
      >
        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>問い合わせ先</h2>
        </div>
        <!-- 事例情報 -->
        <div class="cooperation-detail-information">
          <!-- 事例内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 団体名称 -->
              <tr *ngIf="detailCooperation?.organization_name.length != 0">
                <td class="item-name">団体名称</td>
                <td class="item-information">
                  {{ detailCooperation?.organization_name }}
                </td>
              </tr>
              <!-- 部局名 -->
              <tr *ngIf="detailCooperation?.divition_name.length != 0">
                <td class="item-name">部局名</td>
                <td class="item-information">
                  {{ detailCooperation?.divition_name }}
                </td>
              </tr>
              <!-- 氏名 -->
              <tr
                *ngIf="detailCooperation?.responsible_person_name.length != 0"
              >
                <td class="item-name">氏名</td>
                <td class="item-information">
                  {{ detailCooperation?.responsible_person_name }}
                </td>
              </tr>
              <!-- 電話番号 -->
              <tr *ngIf="detailCooperation?.tel.length != 0">
                <td class="item-name">電話番号</td>
                <td class="item-information">{{ detailCooperation?.tel }}</td>
              </tr>
              <!-- eメールアドレス -->
              <tr *ngIf="detailCooperation?.email.length != 0">
                <td class="item-name">eメールアドレス</td>
                <td class="item-information">{{ detailCooperation?.email }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <div *ngIf="detailCooperation?.sdgs_perspective.length != 0">
        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>優良事例応募項目</h2>
        </div>
        <!-- 事例内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 応募にあたっての記載事項 -->
            <tr>
              <td class="item-name">応募にあたっての記載事項</td>
              <td class="item-information">
                {{ detailCooperation?.sdgs_perspective }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="information-margin-height"></div>

      <div class="no_print">
        <!-- ボタンエリア -->
        <div
          class="p-d-flex p-jc-center button-area"
          *ngIf="
            decisionPerspective(this.detailCooperation?.member_id) ||
            decisionSecretariat()
          "
        >
          <div
            *ngIf="
              (detailCooperation?.status.id == 0 ||
                detailCooperation?.status.name == '一時保存') &&
              !tempSaveFlg
            "
          >
            <button
              pButton
              type="button"
              label="登録"
              icon="pi pi-check"
              class="button3"
              (click)="regist()"
            ></button>
          </div>
          <button
            pButton
            type="button"
            label="編集"
            icon="pi pi-pencil"
            class="button1"
            (click)="moveH101()"
            *ngIf="detailCooperation?.status.id != 3"
          ></button>
          <button
            pButton
            type="button"
            label="印刷"
            icon="pi pi-print"
            class="jirei-button3"
            (click)="print()"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-replay"
            class="jirei-button1"
            onClick="window.location.reload()"
          ></button>
        </div>
        <!-- ボタンエリア -->
        <div
          class="p-d-flex p-jc-center button-area"
          *ngIf="
            !decisionPerspective(this.detailCooperation?.member_id) &&
            !decisionSecretariat()
          "
        >
          <button
            pButton
            type="button"
            label="印刷"
            icon="pi pi-print"
            class="jirei-button3"
            (click)="print()"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 共通部品_承認時ダイアログ -->
<app-approval-dialog
  (returnApproval)="getDetailCooperation()"
></app-approval-dialog>

<!-- 共通部品_差分比較ダイアログ -->
<app-diff-table></app-diff-table>

<!-- フッダー -->
<!-- <footer id="footer"> -->
<footer class="no_print">
  <app-footer></app-footer>
</footer>
